import React, { createContext, useContext } from "react";

export const DragHandleContext = createContext(null);

export const DragHandleProvider = ({ value, children }) => (
  <DragHandleContext.Provider value={value}>{children}</DragHandleContext.Provider>
);

export const useDragHandle = () => useContext(DragHandleContext);


